<div class="link" mat-button [matMenuTriggerFor]="securityMenu" disableRipple>{{ 'security.securitySettings' | transloco }}</div>
<mat-menu #securityMenu="matMenu" xPosition="after">
  <button (click)="onChangePasswordByPasswordClick()" mat-menu-item>{{ 'security.changePassword' | transloco }}</button>
</mat-menu>
